import { PersonSVG } from "@/components/we360/SVGIllustrations";
import { TextInput } from "@/components/we360/TextInput";
import { DateFieldInput } from "@/components/we360/DateFieldInput";
import { PillSelect } from "@/components/we360/PillSelect";
import { CalculatedBadge } from "@/components/we360/CalculatedBadge";
import { calculateAge } from "./helpers";

export default function Step2Personal({ data, setField, errors, onBlur }) {
  const age = calculateAge(data.fechaNacimiento);
  const filled = data.nombres && data.sexo;

  return (
    <div>
      <div className="text-center mb-4">
        <PersonSVG sex={data.sexo} filled={filled} />
      </div>

      {/* Sub-tarjeta 1: Identificación Básica */}
      <div className="glass-card p-5 rounded-3xl mb-5 text-left border border-white/40 shadow-sm">
        <h3 className="text-xs font-bold uppercase tracking-wider text-[#00628F] mb-4">
          Identificación Básica
        </h3>
        
        <div className="flex gap-2.5">
          <div className="flex-1">
            <TextInput
              label="Nombres"
              value={data.nombres}
              onChange={(v) => setField("nombres", v)}
              onBlur={() => onBlur("nombres")}
              placeholder="María"
              error={errors.getError("nombres")}
              testId="input-nombres"
            />
          </div>
          <div className="flex-1">
            <TextInput
              label="Apellidos"
              value={data.apellidos}
              onChange={(v) => setField("apellidos", v)}
              onBlur={() => onBlur("apellidos")}
              placeholder="García"
              error={errors.getError("apellidos")}
              testId="input-apellidos"
            />
          </div>
        </div>

        <DateFieldInput
          label="Fecha de nacimiento"
          value={data.fechaNacimiento}
          onChange={(v) => setField("fechaNacimiento", v)}
          onBlur={() => onBlur("fechaNacimiento")}
          error={errors.getError("fechaNacimiento")}
          testId="input-fecha-nacimiento"
        />

        {age !== null && (
          <CalculatedBadge label="Edad" value={age} unit="años" testId="badge-edad" />
        )}

        <PillSelect
          label="Sexo biológico (al nacer)"
          hint="Requerido exclusivamente para calibrar tus rangos fisiológicos, cardiovasculares y metabólicos."
          options={["Masculino", "Femenino"]}
          value={data.sexo}
          onChange={(v) => setField("sexo", v)}
          error={errors.getError("sexo")}
          testId="pill-sexo"
          columns={2}
        />
      </div>

      {/* Sub-tarjeta 2: Perfil Sociodemográfico */}
      <div className="glass-card p-5 rounded-3xl text-left border border-white/40 shadow-sm">
        <h3 className="text-xs font-bold uppercase tracking-wider text-[#00628F] mb-4">
          Perfil Sociodemográfico
        </h3>

        <PillSelect
          label="Estado civil"
          options={["Soltero(a)", "Casado(a)/Unión libre", "Divorciado(a)", "Viudo(a)"]}
          value={data.estadoCivil}
          onChange={(v) => setField("estadoCivil", v)}
          error={errors.getError("estadoCivil")}
          testId="pill-estado-civil"
        />

        <PillSelect
          label="Nivel educativo"
          options={[
            "Primaria incompleta", "Primaria completa",
            "Secundaria incompleta", "Secundaria completa",
            "Universitario incompleto", "Universitario completo",
            "Técnico", "Especialidad", "Maestría", "Doctorado",
          ]}
          value={data.nivelEducativo}
          onChange={(v) => setField("nivelEducativo", v)}
          error={errors.getError("nivelEducativo")}
          testId="pill-nivel-educativo"
        />

        <div className="flex gap-2.5 mt-2">
          <div className="flex-1">
            <TextInput
              label="Profesión"
              value={data.profesion}
              onChange={(v) => setField("profesion", v)}
              onBlur={() => onBlur("profesion")}
              placeholder="Ej: Médico..."
              error={errors.getError("profesion")}
              testId="input-profesion"
            />
          </div>
          <div className="flex-1">
            <TextInput
              label="Ocupación"
              value={data.ocupacion}
              onChange={(v) => setField("ocupacion", v)}
              onBlur={() => onBlur("ocupacion")}
              placeholder="Ej: Docente..."
              error={errors.getError("ocupacion")}
              testId="input-ocupacion"
            />
          </div>
        </div>

        <PillSelect
          label="Residencia"
          options={["Urbana", "Rural"]}
          value={data.residencia}
          onChange={(v) => setField("residencia", v)}
          error={errors.getError("residencia")}
          testId="pill-residencia"
          columns={2}
        />
      </div>
    </div>
  );
}
